<div class="review-summary" role="status">
  <span
    ><strong>{{ rows.length }}</strong>
    {{ translationService.getImportTotalText() }}</span
  >
  <span
    ><strong>{{ validProducts }}</strong>
    {{ translationService.getImportReadyText() }}</span
  >
  <span
    ><strong>{{ attentionProducts }}</strong>
    {{ translationService.getImportAttentionText() }}</span
  >
</div>
@if (attentionProducts || otherErrors.length) {
  <p>{{ translationService.getValidationErrorsDetectedText() }}</p>
}
@if (attentionProducts) {
  <button
    mat-stroked-button
    type="button"
    class="filter-button"
    [attr.aria-pressed]="onlyAttention"
    (click)="onlyAttention = !onlyAttention"
  >
    {{
      onlyAttention
        ? translationService.getImportShowAllText()
        : translationService.getImportShowIssuesText()
    }}
  </button>
}
@for (entry of otherErrors; track $index) {
  <div class="validation-errors" role="alert">
    <strong
      >{{ translationService.getValidationErrorsText() }} —
      {{
        entry.identifier || translationService.getProductIdentifierText()
      }}</strong
    >
    <ul>
      @for (error of entry.errors; track $index) {
        <li>{{ error }}</li>
      }
    </ul>
  </div>
}
@if (!rows.length) {
  <p>{{ translationService.getImportNoProductsText() }}</p>
}
<div class="review-list">
  @for (row of visibleRows; track row) {
    @let importedProduct = row.importedProduct;
    @let product = importedProduct.product;
    <article class="product-row" [class.needs-attention]="!row.ready">
      <div class="product-heading">
        <div class="product-identity">
          @if (product.picture) {
            <img
              class="product-thumbnail"
              [src]="product.picture"
              alt=""
              width="48"
              height="48"
              loading="lazy"
            />
          }
          <h3>
            {{
              product.name || translationService.getImportUnnamedProductText()
            }}
          </h3>
        </div>
        <span class="validation-status" [class.ready]="row.ready">
          <mat-icon>{{
            row.ready ? 'check_circle' : 'error_outline'
          }}</mat-icon>
          {{
            row.ready
              ? translationService.getValidText()
              : translationService.getImportAttentionText()
          }}
        </span>
      </div>
      <dl class="summary-grid">
        <div>
          <dt>{{ translationService.getProductIdentifierText() }}</dt>
          <dd>
            {{
              product.primaryArticleIdentifier || translationService.getNaText()
            }}
          </dd>
        </div>
        <div>
          <dt>{{ translationService.getMarketplaceCategoryLabelText() }}</dt>
          <dd>
            {{
              translationService.getMarketplaceCategoryText(
                product.marketplaceCategory
              )
            }}
          </dd>
        </div>
        <div>
          <dt>{{ translationService.getMarketplaceRequestUnitText() }}</dt>
          <dd>
            {{
              translationService.getMarketplaceRequestUnitValueText(
                product.requestUnit
              )
            }}
          </dd>
        </div>
        <div>
          <dt>{{ translationService.getMarketplacePriceText() }}</dt>
          <dd>
            {{
              product.priceAmount ??
                translationService.getMarketplaceUnknownText()
            }}
          </dd>
        </div>
        <div>
          <dt>{{ translationService.getMarketplaceCurrencyText() }}</dt>
          <dd>{{ product.priceCurrency || translationService.getNaText() }}</dd>
        </div>
        <div>
          <dt>{{ translationService.getKeepProductPrivateText() }}</dt>
          <dd>{{ getBoolText(product.isMarketplacePrivate) }}</dd>
        </div>
        <div>
          <dt>{{ translationService.getAllowRequestsText() }}</dt>
          <dd>{{ getBoolText(product.allowRequests ?? false) }}</dd>
        </div>
      </dl>
      @if (row.errors.length) {
        <div class="validation-errors">
          <strong>{{ translationService.getValidationErrorsText() }}</strong>
          <ul>
            @for (error of row.errors; track $index) {
              <li>{{ error }}</li>
            }
          </ul>
        </div>
      } @else if (!row.ready) {
        <p class="validation-errors">
          {{ translationService.getImportLinkedIssuesText() }}
        </p>
      }
      <details class="product-details">
        <summary>
          {{ translationService.getImportProductDetailsText() }}
        </summary>
        @if (product.picture) {
          <img
            class="product-image"
            [src]="product.picture"
            [alt]="translationService.getProductPictureText()"
          />
        }
        <dl class="details-grid">
          @for (detail of row.details; track $index) {
            <div>
              <dt>{{ detail.label }}</dt>
              <dd>{{ detail.value }}</dd>
            </div>
          }
        </dl>
        <app-product-custom-fields [fields]="product.customFields" />
        <div class="detail-actions">
          @if (importedProduct.product.safetyDataSheet?.length) {
            <button
              mat-stroked-button
              class="file-button"
              extended
              color="primary"
              (click)="openPdfInNewTab(importedProduct.product.safetyDataSheet)"
            >
              <mat-icon>open_in_new</mat-icon>
              {{ translationService.getSafetyDataSheetText() }}
            </button>
          }

          @if (importedProduct.product.recyclingInstructions?.length) {
            <button
              mat-stroked-button
              extended
              color="primary"
              class="file-button"
              (click)="
                openPdfInNewTab(importedProduct.product.recyclingInstructions)
              "
            >
              <mat-icon>open_in_new</mat-icon>
              {{ translationService.getRecyclingInstructionsText() }}
            </button>
          }

          @if (importedProduct.ingredients?.length) {
            <button
              mat-stroked-button
              extended
              color="primary"
              class="file-button"
              (click)="showIngredients(importedProduct.ingredients)"
            >
              <mat-icon>science</mat-icon>
              {{ translationService.getIngredientsText() }}
            </button>
          }
        </div>
        <div class="detail-actions">
          @if (importedProduct.product.provincialRecyclability?.length) {
            <button
              mat-stroked-button
              extended
              color="primary"
              class="file-button"
              (click)="
                showProvincialRecyclability(
                  importedProduct.product.provincialRecyclability
                )
              "
            >
              <mat-icon>map</mat-icon>
              {{ translationService.getProvincialRecyclabilityText() }}
            </button>
          }

          @if (importedProduct.product.countryRecyclability?.length) {
            <button
              mat-stroked-button
              extended
              color="primary"
              class="file-button"
              (click)="
                showCountryRecyclability(
                  importedProduct.product.countryRecyclability
                )
              "
            >
              <mat-icon>public</mat-icon>
              {{ translationService.getCountryRecyclabilityText() }}
            </button>
          }

          @if (importedProduct.product.ghsClassifications?.length) {
            <button
              mat-stroked-button
              extended
              color="primary"
              class="file-button"
              (click)="
                showGhsClassifications(
                  importedProduct.product.ghsClassifications
                )
              "
            >
              <mat-icon>warning</mat-icon>
              {{ translationService.getGhsClassificationsText() }}
            </button>
          }
        </div>
        <div class="detail-actions">
          @if (hasValue(importedProduct.product.plasticsDeclaration)) {
            <button
              mat-stroked-button
              extended
              color="primary"
              class="file-button"
              (click)="
                showPlasticsDeclaration(
                  importedProduct.product.plasticsDeclaration
                )
              "
            >
              <mat-icon>recycling</mat-icon>
              {{ translationService.getPlasticsDeclarationText() }}
            </button>
          }

          @if (importedProduct.resins?.length) {
            <button
              mat-stroked-button
              extended
              color="primary"
              class="file-button"
              (click)="showResins(importedProduct.resins)"
            >
              <mat-icon>polymer</mat-icon>
              {{ translationService.getResinsText() }}
            </button>
          }

          @if (
            importedProduct.components?.length ||
            importedProduct.componentGroups?.length
          ) {
            <button
              mat-stroked-button
              extended
              color="primary"
              class="file-button"
              (click)="
                showComponents(
                  importedProduct.components,
                  importedProduct.componentGroups
                )
              "
            >
              <mat-icon>account_tree</mat-icon>
              {{ translationService.getComponentsText() }}
            </button>
          }
        </div>
      </details>
    </article>
  }
</div>
